<div [class]="effectiveContainerClass()">
  @if (!hideLabel() || label()) {
    <label
      class="checklist-task-label label"
      [class.sr-only]="hideLabel()"
      [attr.for]="id() || null">
      {{ labelText() }}
    </label>
  }

  <div class="relative w-full">
    <input
      #inputRef
      [attr.id]="id() || null"
      [attr.data-testid]="testId() || null"
      class="checklist-input w-full"
      [class.pr-10]="type() !== 'password'"
      [class.pr-16]="type() === 'password'"
      [class]="inputClass()"
      [class.has-prefix-icon]="prefixIcon() !== ''"
      [attr.type]="effectiveType()"
      [attr.placeholder]="placeholder() || null"
      [attr.autocomplete]="autocomplete() || null"
      [formField]="field()" />
    @if (prefixIcon()) {
      <svg-icon
        [src]="prefixIcon()"
        svgClass="w-5 h-5"
        class="absolute left-[0.875rem] top-1/2 -translate-y-1/2 w-5 h-5 text-tertiary pointer-events-none" />
    }
    @if (type() === 'password') {
      <button
        type="button"
        (click)="togglePasswordVisibility()"
        class="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-tertiary focus:outline-none"
        [attr.aria-label]="
          passwordVisible() ? 'Hide password' : 'Show password'
        ">
        <svg-icon
          [src]="
            passwordVisible()
              ? '/assets/svg/eye-off.svg'
              : '/assets/svg/eye.svg'
          "
          svgClass="w-6 h-6"
          class="w-5 h-5" />
      </button>
    }
    @if (showError()) {
      <svg-icon
        src="/assets/svg/alert-circle.svg"
        [class]="
          type() === 'password'
            ? 'absolute right-9 top-1/2 -translate-y-1/2 w-5 h-5 pointer-events-none text-error-primary'
            : 'absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 pointer-events-none text-error-primary'
        "
        svgClass="w-5 h-5" />
    }
  </div>
  @if (showError()) {
    <p class="text-error-primary m-0 p-0">{{ errorMessage() }}</p>
  }
</div>
